'use strict';

var Sugar = require('sugar-core');

require('./build/buildMathAliasesCall');

module.exports = Sugar.Number.sin;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/sin.js
// module id = 740
// module chunks = 0